import React from 'react'
import {Helmet} from "react-helmet"
import Container from '@material-ui/core/Container';

import { ReactComponent as Onda } from '../../assets/onda.svg';

import './Home.scss';

import TagManager from 'react-gtm-module'

const pushGTM = () => TagManager.dataLayer({
    dataLayer: {
        'event': 'pageview'
    },
    dataLayerName: 'pageview'
});

const AccountDeletion = () => {

    React.useEffect(() => {
        pushGTM();
    }, []);

    const email = process.env.REACT_APP_ACCOUNT_DELETION_EMAIL || 'info@rivemo.it';

    return (
        <div>
            <Helmet defaultTitle="Cancellazione Account - Rivemo!">
                <title>Cancellazione Account - Rivemo!</title>
                <meta name="description" content="Istruzioni su come richiedere la cancellazione del proprio account e dei dati personali su Rivemo." />
            </Helmet>
            <div className="top-location in-cart">
                <Onda className="onda" />
                <div className="shop-products thank-you">
                    <Container style={{ maxWidth: '1180px', position: 'relative', zIndex:0, padding: '0' }} fixed>
                        <br className="mob" /><br className="mob" />
                        <p><strong>CANCELLAZIONE ACCOUNT</strong></p>
                        <p>In conformità con le linee guida degli store Apple e Android, forniamo di seguito le istruzioni su come richiedere la cancellazione del proprio account e di tutti i dati personali associati ai nostri servizi.</p>

                        <p><strong>COME RICHIEDERE LA CANCELLAZIONE</strong></p>
                        <p>Per richiedere la rimozione definitiva dei tuoi dati, è necessario inviare una comunicazione scritta via email all'indirizzo:</p>
                        <p><strong><a href={`mailto:${email}`}>{email}</a></strong></p>
                        <p>La richiesta deve essere inviata obbligatoriamente dall'indirizzo di posta elettronica utilizzato in fase di registrazione all'app o al sito Rivemo, al fine di garantire l'autenticità della richiesta.</p>

                        <p><strong>COSA SCRIVERE NELL'EMAIL</strong></p>
                        <p>Per velocizzare il processo, ti preghiamo di compilare l'email come segue:</p>
                        <ul>
                            <li><strong>Oggetto:</strong> Richiesta di cancellazione dati account</li>
                            <li><strong>Corpo del messaggio:</strong>
                                <ul>
                                    <li>Nome e Cognome del titolare dell'account</li>
                                    <li>Indirizzo email associato all'account</li>
                                    <li>Una dichiarazione esplicita (es: "Richiedo la cancellazione permanente del mio account Rivemo e di tutti i dati personali ad esso associati").</li>
                                </ul>
                            </li>
                        </ul>

                        <p><strong>PROCESSO DI CANCELLAZIONE</strong></p>
                        <ol>
                            <li><strong>Ricezione:</strong> Una volta ricevuta l'email, il nostro team tecnico prenderà in carico la tua richiesta.</li>
                            <li><strong>Verifica:</strong> Procederemo alla verifica dell'identità per assicurarci che la richiesta provenga dal legittimo proprietario.</li>
                            <li><strong>Eliminazione:</strong> Dopo la conferma, i dati verranno rimossi dai nostri sistemi in modo definitivo.</li>
                            <li><strong>Conferma:</strong> Riceverai un'email di notifica una volta che l'operazione sarà stata completata con successo.</li>
                        </ol>

                        <p><strong>TEMPISTICHE E NOTE IMPORTANTI</strong></p>
                        <p>Il completamento dell'intera procedura può richiedere fino a <strong>30 giorni</strong> lavorativi, a seconda della complessità dei dati da rimuovere.</p>
                        <p><em>Nota: l'operazione di cancellazione è irreversibile. Una volta completata, non sarà più possibile recuperare l'accesso all'account, allo storico ordini o a eventuali crediti residui. Alcune informazioni potrebbero essere conservate esclusivamente per il tempo necessario ad adempiere a specifici obblighi di legge o fiscali.</em></p>
                        <br className="mob" /><br className="mob" />
                    </Container>
                </div>
            </div>
        </div>
    )
}

export default AccountDeletion;
